/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { patchedReserveUpdateRequestSchema } from "./patchedReserveUpdateRequestSchema.ts";
import { reserveSchema } from "./reserveSchema.ts";

export const orgUnitReserveUpdatePartialUpdatePathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveUpdatePartialUpdatePathReserveIdSchema = z.uuid();

export const orgUnitReserveUpdatePartialUpdateStatus200Schema = reserveSchema;

export const orgUnitReserveUpdatePartialUpdateResponseSchema = orgUnitReserveUpdatePartialUpdateStatus200Schema;

export const orgUnitReserveUpdatePartialUpdateDataSchemaJson = patchedReserveUpdateRequestSchema
	.optional()
	.describe("Перенос брони: время и стол можно менять по отдельности или вместе.");

export const orgUnitReserveUpdatePartialUpdateDataSchemaXml = patchedReserveUpdateRequestSchema
	.optional()
	.describe("Перенос брони: время и стол можно менять по отдельности или вместе.");

export const orgUnitReserveUpdatePartialUpdateDataSchema = z.union([
	orgUnitReserveUpdatePartialUpdateDataSchemaJson,
	orgUnitReserveUpdatePartialUpdateDataSchemaXml,
]);
